export var getNodeByName = function (name, formRef) {
    if (formRef === null || formRef === void 0 ? void 0 : formRef.current) {
        var input = formRef.current.querySelector("[name=\"" + name + "\"]");
        if (input) {
            return {
                current: input,
            };
        }
    }
    else {
        var input = document.querySelector("[name=\"" + name + "\"]");
        if (input) {
            return {
                current: input,
            };
        }
    }
    return null;
};
